import { render, staticRenderFns } from "./ExamSingleChoiceSimple.vue?vue&type=template&id=bdff4a0c&"
import script from "./ExamSingleChoiceSimple.vue?vue&type=script&lang=js&"
export * from "./ExamSingleChoiceSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports